if (!customElements.get("product-inventory")) {
  class t extends HTMLElement {
    constructor() {
      super(), window.initLazyScript(this, this.initLazySection.bind(this))
    }
    initLazySection() {
      this.inventoryNotice = this.querySelector(".js-inventory-notice"), this.urgencyMessage =
        this.querySelector(".js-inventory-urgency"), this.indicatorBar = this.querySelector(
          ".js-inventory-indicator"), this.variantInventory = this.getVariantInventory();
      let t = this.closest(".product-info").querySelector("variant-picker");
      t && t.addEventListener("on:variant:change", this.handleVariantChange.bind(this)), this
        .updateInventory(parseInt(this.dataset.inventoryQuantity, 10), "true" === this.dataset
          .variantAvailable, this.dataset.inventoryPolicy)
    }
    getVariantInventory() {
      let t = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(t.textContent)
    }
    handleVariantChange(t) {
      if (t.detail.variant) {
        let e = this.variantInventory.filter(e => e.id === t.detail.variant.id)[0];
        this.updateInventory(e.inventory_quantity, e.available, e.inventory_policy)
      } else this.updateInventory(0, !1), this.hidden = !0
    }
    updateInventory(t, e, i) {
      let n;
      if (n = t <= 0 ? "continue" === i ? "backordered" : e ? "in_stock" : "none" : t <= parseInt(
          this.dataset.thresholdVeryLow, 10) ? "very_low" : t <= parseInt(this.dataset
          .thresholdLow, 10) ? "low" : "normal", ("always" === this.dataset.showNotice ||
          "low" === this.dataset.showNotice && n.includes("low")) && !("backordered" === n &&
          "false" === this.dataset.showNoStockBackordered)) {
        if (this.hidden = !1, this.setAttribute("data-inventory-level", n), "backordered" === n ?
          this.inventoryNotice.innerText = "" : "in_stock" !== n && ("always" === this.dataset
            .showCount || "low" === this.dataset.showCount && n.includes("low")) ? this
          .inventoryNotice.innerText = theme.strings.onlyXLeft.replace("[quantity]", t) :
          "very_low" === n ? this.inventoryNotice.innerText = theme.strings.veryLowStock :
          "low" === n ? this.inventoryNotice.innerText = theme.strings.lowStock : "normal" ===
          n || "in_stock" === n ? this.inventoryNotice.innerText = theme.strings.inStock :
          "none" === n && (this.inventoryNotice.innerText = theme.strings.noStock), this
          .urgencyMessage && ("very_low" === n ? this.urgencyMessage.innerHTML = this.dataset
            .textVeryLow : "low" === n ? this.urgencyMessage.innerHTML = this.dataset.textLow :
            "backordered" === n ? this.urgencyMessage.innerHTML = this.dataset
            .textNoStockBackordered : "normal" === n || "in_stock" === n ? this.urgencyMessage
            .innerHTML = this.dataset.textNormal : "none" === n && (this.urgencyMessage
              .innerHTML = this.dataset.textNoStock)), this.indicatorBar) {
          this.indicatorBar.hidden = !1;
          let s;
          s = (t >= this.dataset.scale || "in_stock" === n) && "backordered" !== n ? 100 : (100 /
            parseInt(this.dataset.scale, 10) * t).toFixed(1), this.indicatorBar.querySelector(
            "span").style.width = `${s}%`
        }
      } else this.hidden = !0
    }
  }
  customElements.define("product-inventory", t)
}
